import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["contentId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQueryClient, useMutation } from 'react-query';
import api from 'utils/api';
import contentCommentSubscriptionKeys from './queryKeys';
function useUpdateMyContentCommentSubscription(_ref) {
  var contentId = _ref.contentId,
    options = _objectWithoutProperties(_ref, _excluded);
  var queryClient = useQueryClient();
  function updateMyContentCommentSubscription(_x) {
    return _updateMyContentCommentSubscription.apply(this, arguments);
  }
  function _updateMyContentCommentSubscription() {
    _updateMyContentCommentSubscription = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(isSubscribed) {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('patch', "/api/me/content/subscriptions/".concat(contentId), null, {
              isSubscribed: isSubscribed
            });
          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateMyContentCommentSubscription.apply(this, arguments);
  }
  var _useMutation = useMutation(updateMyContentCommentSubscription, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess() {
        queryClient.invalidateQueries(contentCommentSubscriptionKeys.contentSubscriptions(contentId));
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    updateMyContentCommentSubscription: mutateAsync
  });
}
export default useUpdateMyContentCommentSubscription;